import React, { useState, useEffect } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate, useParams } from 'react-router-dom';

const EditGoodsReceiptNote = () => {
    const [formData, setFormData] = useState(null);  // Start with null instead of an empty object
    const { id } = useParams(); // Get the id from the URL parameters
    const navigate = useNavigate();

    // Fetch existing Goods Receipt Note data when component mounts
    useEffect(() => {
        fetch(`${BASE_URL}goodsreceiptnote/${id}`)
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success' && data.goods_receipt_note) {
                    // Pre-fill the form with the data
                    setFormData(data.goods_receipt_note); // Assuming the fetched data has a 'goods_receipt_note' field
                } else {
                    alert('Error fetching data for editing. Please try again.');
                }
            })
            .catch((error) => {
                console.error('Error fetching Goods Receipt Note data:', error);
                alert('An error occurred while fetching the data. Please try again.');
            });
    }, [id]); // Dependency array to ensure it runs when 'id' changes

    // Handle form data changes
    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
    };

    // Handle form submission for updating the Goods Receipt Note
    const handleSubmit = (event) => {
        event.preventDefault();

        // Send the updated data to the API
        fetch(`${BASE_URL}goodsreceiptnote/${id}`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData),
        })
            .then((response) => response.json())
            .then((data) => {
                if (data.status === 'success') {
                    alert('Goods Receipt Note updated successfully!');
                    navigate('/GoodsReceiptNotesList'); // Navigate to the list page after successful update
                } else {
                    alert(`Error updating Goods Receipt Note: ${data.message || 'Please try again'}`);
                }
            })
            .catch((error) => {
                console.error('Error updating Goods Receipt Note:', error);
                alert('An error occurred. Please check the console for more details.');
            });
    };

    if (!formData) {
        // If formData is not loaded yet, return loading message
        return <div>Loading...</div>;
    }

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Goods Receipt Note</h3>
                        </div>
                        <div className="col-12 col-md-6 order-md-2 order-first">
                            <nav aria-label="breadcrumb" className="breadcrumb-header float-start float-lg-end">
                                <ol className="breadcrumb">
                                    {/* Additional breadcrumb items can be added here */}
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>

            {/* Edit Goods Receipt Note Form */}
            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">Edit Goods Receipt Note</h4>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    {/* Add all form fields here */}
                                    {formData && Object.keys(formData).length > 0 && Object.keys(formData).map((field, idx) => (
                                        <div key={idx} className="mb-3">
                                            <label htmlFor={field} className="form-label">
                                                {field.replace(/_/g, ' ').toUpperCase()}
                                            </label>
                                            <input
                                                type="text"
                                                id={field}
                                                name={field}
                                                className="form-control"
                                                value={formData[field]}
                                                onChange={handleChange}
                                                placeholder={`Enter ${field.replace(/_/g, ' ')}`}
                                                required
                                            />
                                        </div>
                                    ))}
                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">Update Goods Receipt Note</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* End Edit Goods Receipt Note Form */}
        </div>
    );
};

export default EditGoodsReceiptNote;
